import { useContext } from "react";
import checkoutContext from "../../../../checkout-context";
import { Address } from "../../types/Types";
import { FormField } from "../fields/FormField";
import { CountrySelect } from "../fields/CountrySelect";
import { getAddressDetailsEvent } from "../formPrefills";

type PersonalAddressFormProps = { defaultValues: Partial<Address> };

export function PersonalAddressForm({
  defaultValues = {},
}: PersonalAddressFormProps) {
  const { textsMapping, addressEndpointUrl } = useContext(checkoutContext);
  const prefillAddresDetails = getAddressDetailsEvent(addressEndpointUrl);

  return (
    <FormField.Section
      title={textsMapping.homeAddressDataTitle}
      description={textsMapping.homeAddressDataText}
    >
      <CountrySelect defaultValues={defaultValues} />
      <FormField
        name="address.zip"
        defaultValue={defaultValues.zip}
        label={textsMapping.homeAddressZipLabel}
        placeholder={textsMapping.homeAddressZipPlaceholder}
        onBlur={prefillAddresDetails}
        required
      />
      <FormField.Group>
        <FormField
          name="address.houseNumber"
          type="number"
          defaultValue={defaultValues.houseNumber}
          label={textsMapping.homeAddressHouseNumberLabel}
          placeholder={textsMapping.homeAddressHouseNumberPlaceholder}
          onBlur={prefillAddresDetails}
          required
        />
        <FormField
          name="address.houseNumberAddition"
          defaultValue={defaultValues.houseNumberAddition}
          label={textsMapping.homeAddressHouseNumberAdditionLabel}
          placeholder={textsMapping.homeAddressHouseNumberAdditionPlaceholder}
        />
      </FormField.Group>
      <FormField
        name="address.street"
        defaultValue={defaultValues.street}
        label={textsMapping.homeAddressStreetLabel}
        placeholder={textsMapping.homeAddressStreetPlaceholder}
        required
      />
      <FormField
        name="address.city"
        defaultValue={defaultValues.city}
        label={textsMapping.homeAddressLocationLabel}
        placeholder={textsMapping.homeAddressLocationPlaceholder}
        required
      />
    </FormField.Section>
  );
}
